import styled from 'styled-components'

const Card = styled.div`
	background-color: ${(props) => props.color};
	border-radius: 20px;
`

export default Card
